import React from 'react'
import './ConfirmationNotification.css'
import { motion } from 'framer-motion'
import { backdropTransition, popupTransition, transitionDuration } from '../../Util/PageTransitions'
import CornerCloseButton from '../CornerCloseButton/CornerCloseButton'

export default function ConfirmationNotification(props) {
    return (
        <motion.div className='confirmationNotification' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
            <div className='confirmationNotificationBackdrop' onMouseDown={props.closeNotification} />
            <motion.div className='confirmationNotificationContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                <CornerCloseButton onClick={props.closeNotification} />
                <h1 className='confirmationNotificationHeader'>{props.header}</h1>
                <p className='confirmationNotificationText'>{props.body}</p>
                <div className='confirmationNotificationButtonContainer'>
                    {props.confirmFunction && <button className='confirmationNotificationButton secondaryButton' onMouseDown={props.closeNotification}>Cancel</button>}
                    <button className='confirmationNotificationButton primaryButton' style={{ justifySelf: 'end', gridColumn: 2 }} onMouseDown={props.confirmFunction ? props.confirmFunction : props.closeNotification}>{props.confirmFunction ? 'Confirm' : 'Continue'}</button>
                </div>
            </motion.div>
        </motion.div>
    )
}
